export default __webpack_public_path__ + "static/media/title.8a0ee054.svg";